import { jsx as _jsx } from "react/jsx-runtime";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { trackCategoriesBreadcrumbNavClick } from "@faire/web-api--source/events/categories/click/breadcrumbNav";
import React, { useMemo } from "react";
import { Breadcrumb } from "@faire/retailer/components/Breadcrumb";
import { getCategoryBreadcrumbOptions } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageAboveFold/__internal__/utils";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useLoggedOutCategoryPageMetaTags } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageMetaTags";
export var LoggedOutCategoryPageBreadcrumb = function(param) {
    var className = param.className;
    var categoryModel = useLoggedOutCategoryPageCurrentCategory();
    var seoCategoryText = useLoggedOutCategoryPageMetaTags().seoCategoryText;
    var applied_filter_display_name = (seoCategoryText !== null && seoCategoryText !== void 0 ? seoCategoryText : {}).applied_filter_display_name;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var routingContext = useRetailerRoutingContext();
    var breadcrumbOptions = useMemo(function() {
        return categoryModel ? getCategoryBreadcrumbOptions(categoryModel, strictLocalize, routingContext, applied_filter_display_name !== null && applied_filter_display_name !== void 0 ? applied_filter_display_name : "") : [];
    }, [
        applied_filter_display_name,
        categoryModel,
        routingContext,
        strictLocalize
    ]);
    return /*#__PURE__*/ _jsx(Breadcrumb, {
        className: className,
        hideRoot: true,
        options: breadcrumbOptions,
        onClick: function(option) {
            var _option_path;
            trackCategoriesBreadcrumbNavClick((_option_path = option.path) !== null && _option_path !== void 0 ? _option_path : "");
        }
    });
};
